// src/components/SubscriptionCard.tsx
import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { PlanData } from '../../services/types';
import { createCheckoutSession, phonePeCheckoutSession, phonePeCheckoutSessionToken,  createCheckoutSessionToken} from '../../services/apiService';
import ReusableButton from '../Reusable/PrimaryButton/PrimaryButton';
import { showToast } from '../Toast/CommonToast';
import { useNavigate } from 'react-router-dom';
 
// interface SubscriptionCardProps {
//   title: string;
//   price: string;
//   description: string;
//   features: string[];
//   buttonLabel: string;
//   buttonColor: string;
//   isCurrentPlan?: boolean;
// }
 
 
 
 
const SubscriptionCard = (props: PlanData) => {
  const navigate = useNavigate();
 
  const handleCheckoutSession = async () => {
    const isUsd = props.selectedCurrency === 'USD';
    const isInr = props.selectedCurrency === 'INR';

    if (!isUsd && !isInr) {
      return;
    }

    const unitAmount = isUsd ? props.totalCost : props.totalInrCost;
    const currency = isUsd ? 'usd' : 'INR';

    const obj: any = {
      "userId": props?.paramsUserId || localStorage.getItem("userId"),
      "priceId": props.stripe_product_price_id,
      "productId": props.stripe_product_id,
      "productName": props.name,
      "quantity": 1,
      "currency": currency,
      "unit_amount": unitAmount,
      "total_amount": unitAmount,
      "credit_points": props.totalCredit
    };

    localStorage.setItem("selectedPlan", JSON.stringify(obj));

    try {
      const createCheckoutSessionResponse = isUsd
        ? (props.encryptRedirectToken
          ? await createCheckoutSessionToken(obj, props.encryptRedirectToken)
          : await createCheckoutSession(obj))
        : (props.encryptRedirectToken
          ? await phonePeCheckoutSessionToken(obj, props.encryptRedirectToken)
          : await phonePeCheckoutSession(obj));

      console.log(createCheckoutSessionResponse);

      if (createCheckoutSessionResponse.status === "success") {
        localStorage.setItem("orderId", createCheckoutSessionResponse.data.orderId);
        window.location.href = createCheckoutSessionResponse.data.sessionUrl;
      }
    } catch (error: any) {
      if (!props?.encryptRedirectToken) {
        showToast(error?.message, 'error');
      }

      if (error.message === "Redirect token already used" || error.message === "Redirect token expired") {
        showToast("This payment link has expired or has already been used. Please request a new payment link and try again ", "error");
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    }
  }
  return (
    <Paper
      elevation={3}
      sx={{
        p: 4,
        maxWidth: 300,
        textAlign: 'start',
        border: '2px solid #64526E',
        backgroundColor: "#33365D",
        borderRadius: 3,
        // height: "450px",
        height: '100%',
        minHeight: '450px',
        position: 'relative',
      }}
    >
      {/* {props.name === "Eternal Love Pack" && (
        <Box className="ribbon-price-container">
          <Typography variant="h4" className="price-text">Valentine's Week Exclusive</Typography>
        </Box>
      )} */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        {props.name}
      </Typography>
      {props.name !== 'Enterprise' && (
        <Typography variant="h4" color="white" gutterBottom>
          {props.selectedCurrency === 'INR' ? `₹${props.totalInrCost}` : `$${props.totalCost}`}
        </Typography>
      )}
      <Typography variant="body1" gutterBottom>
        {props.description}
      </Typography>
 
      {props.name !== 'Enterprise' && <ReusableButton onClick={handleCheckoutSession} variant="contained" fullWidth>
        Get Started
      </ReusableButton>}
 
      <Box sx={{ mt: 2, textAlign: 'left' }}>
        {props.features.map((feature: string, index: number) => {
          const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;
          const emailMatch = feature.match(emailRegex);
          if (props.name === 'Enterprise' && emailMatch !== null) {
            const email = emailMatch[0];
            const before = feature.substring(0, feature.indexOf(email));
            const after = feature.substring(feature.indexOf(email) + email.length);
 
            return (
              <Typography key={index} variant="body2" sx={{ mb: 1 }}>
                ✓ {before}
                <a
                  href={`mailto:${email}`}
                  style={{ color: '#1976d2', textDecoration: 'underline' }}
                >
                  {email}
                </a>
                {after}
              </Typography>
            );
          }
 
          return (
            <Typography key={index} variant="body2" sx={{ mb: 1 }}>
              ✓ {feature}
            </Typography>
          );
        })}
      </Box>
 
    </Paper>
  );
};
 
export default SubscriptionCard;